var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 234,
    viewBox: "0 0 435 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 434.935,
    height: 234,
    rx: 17.8,
    fill: "#1560BD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1779_1410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 430,
    height: 234
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 430,
    height: 234,
    rx: 17.8,
    fill: "#ED713C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1779_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.944 26.7392C281.612 44.6741 305.898 57.1316 324.538 57.7633C346.018 58.489 354.81 43.3323 370.934 48.8094C385.649 53.8024 385.845 68.9853 396.698 71.8772C406.672 74.5345 423.024 66.1147 451.335 22.0098",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.173 19.9445C422.211 63.4091 405.834 72.1821 395.699 69.9242C388.187 68.2403 385.601 60.7529 379.936 54.732C377.112 51.637 373.573 49.2999 369.637 47.9304C356.742 43.4344 348.563 51.6918 334.43 54.744C330.827 55.5329 327.145 55.8906 323.459 55.8097C304.731 55.4605 280.653 44.5226 278.573 27.2189",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.008 17.8847C421.395 60.706 405.002 69.8296 394.727 67.9689C387.174 66.6005 384.398 59.4557 378.708 53.7264C375.809 50.7346 372.273 48.4519 368.369 47.0524C355.666 42.5005 347.529 49.9032 333.355 52.7809C329.752 53.5199 326.084 53.8794 322.408 53.8538C303.59 53.7285 279.721 44.3719 277.229 27.6994",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.847 15.8302C420.589 57.9992 404.172 67.4698 393.744 66.0151C386.144 64.9558 383.191 58.1602 377.466 52.719C374.498 49.8323 370.968 47.603 367.101 46.1732C354.577 41.5648 346.508 48.1171 332.278 50.8166C328.674 51.5136 325.015 51.8781 321.346 51.9056C302.441 52.0382 278.782 44.229 275.878 28.1877",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.686 13.7597C419.777 55.2945 403.346 65.1066 392.758 64.0574C385.119 63.3044 381.974 56.8575 376.218 51.7137C373.178 48.9306 369.647 46.7521 365.81 45.2923C353.465 40.6275 345.457 46.3258 331.164 48.8499C327.566 49.4968 323.925 49.8625 320.272 49.9438C301.275 50.3341 277.827 44.0693 274.507 28.6591",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.536 11.7017C418.966 52.5957 402.498 63.0471 391.77 62.1085C384.112 61.4472 380.755 55.5821 374.974 50.7115C371.865 48.0368 368.333 45.9093 364.527 44.4177C352.362 39.6964 344.419 44.5411 330.086 46.8877C326.491 47.4924 322.862 47.8623 319.22 47.9951C300.132 48.6555 276.895 43.9258 273.164 29.1437",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.357 9.63707C418.151 49.8885 401.694 60.365 390.784 60.1699C383.08 59.9933 379.53 54.2827 373.727 49.7007C370.551 47.1355 367.018 45.0578 363.244 43.5347C351.257 38.7569 343.371 42.7506 328.994 44.9195C325.403 45.4785 321.785 45.8506 318.155 46.0344C298.977 46.9525 275.95 43.7795 271.806 29.6194",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.197 7.57346C417.348 47.185 400.873 58.0089 389.798 58.1976C382.061 58.34 378.299 53.0109 372.481 48.6964C369.242 46.243 365.707 44.2161 361.962 42.6643C350.158 37.8271 342.329 40.9637 327.905 42.964C324.549 43.4255 320.969 43.8521 317.093 44.0893C297.82 45.2743 275.008 43.6243 270.451 30.1015",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.034 5.50908C416.528 44.477 400.05 55.6182 388.813 56.2493C381.042 56.6828 377.065 51.7352 371.228 47.6941C367.924 45.3538 364.385 43.3736 360.67 41.7865C349.045 36.8929 341.278 39.1818 326.804 40.998C323.435 41.4219 319.864 41.8428 316.017 42.1337C296.677 43.5837 274.063 43.4713 269.095 30.5829",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.87 3.45057C415.716 41.7752 399.23 53.2365 387.827 54.2884C380.025 55.0101 375.817 50.4555 369.992 46.6862C366.629 44.4605 363.086 42.5261 359.401 40.9034C347.952 35.9532 340.245 37.3882 325.724 39.042C322.356 39.429 318.783 39.8497 314.963 40.1912C295.51 41.9195 273.12 43.3398 267.739 31.0794",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.705 1.38635C414.903 39.0708 398.406 50.8459 386.847 52.3343C379.013 53.3412 374.586 49.1864 368.75 45.6754C365.327 43.5688 361.778 41.6812 358.122 40.0234C346.856 35.017 339.208 35.6011 324.638 37.0615C321.257 37.4048 317.692 37.8289 313.904 38.2182C294.36 40.2257 272.184 43.172 266.385 31.5426",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.544 -0.675202C414.091 36.3659 397.58 48.4577 385.855 50.3822C377.987 51.6711 373.337 47.922 367.502 44.6699C364.147 42.8018 360.711 40.9145 356.835 39.1456C345.747 34.0857 338.16 33.8128 323.543 35.0985C320.154 35.4014 316.596 35.8289 312.83 36.2654C293.193 38.5522 271.229 43.0244 265.021 32.0233",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.381 -2.73886C413.278 33.6496 396.773 46.0623 384.87 48.4254C376.968 49.9993 372.086 46.6617 366.255 43.6624C362.813 41.892 359.366 40.0535 355.551 38.2659C344.643 33.1403 337.119 32.0259 322.451 33.1337C319.056 33.3931 315.5 33.8238 311.771 34.3113C292.046 36.8837 270.29 42.8756 263.67 32.5026",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.228 -4.80137C412.469 30.9559 395.936 43.6631 383.888 46.4694C375.952 48.3191 370.839 45.4053 365.011 42.6527C361.48 40.986 358.024 39.1934 354.283 37.3845C343.551 32.2116 336.093 30.2343 321.364 31.1636C317.958 31.3855 314.411 31.8197 310.711 32.3517C290.893 35.2157 269.349 42.7273 262.317 32.9824",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.055 -6.86139C411.654 28.2529 395.117 41.2588 382.899 44.5165C374.926 46.6449 369.583 44.1581 363.766 41.6495C360.145 40.0895 356.676 38.3363 352.987 36.5083C342.44 31.2792 335.036 28.4508 320.272 29.2028C316.71 29.4216 313.163 29.8247 309.642 30.4105C289.739 33.551 268.395 42.5725 260.959 33.4654",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.895 -8.92458C410.843 25.5464 394.276 38.8622 381.926 42.5636C373.916 44.9677 368.34 42.9139 362.519 40.6423C358.807 39.1923 355.33 37.4787 351.706 35.6291C341.336 30.3434 333.994 26.6612 319.189 27.2387C315.633 27.4111 312.092 27.8149 308.587 28.4477C288.587 31.9042 267.462 42.4243 259.601 33.9571",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.733 -10.9856C410.033 22.8452 393.435 36.4462 380.93 40.612C372.89 43.2858 367.078 41.6772 361.276 39.6408C357.474 38.3036 353.989 36.6206 350.427 34.7522C340.239 29.4102 332.954 24.877 318.093 25.2763C314.542 25.4063 311.006 25.814 307.518 26.4957C287.438 30.2383 266.519 42.2747 258.246 34.4264",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.565 -13.0471C409.218 20.1281 392.615 34.0401 379.943 38.6574C371.857 41.6064 365.821 40.4466 360.03 38.6356C356.125 37.417 352.642 35.7649 349.142 33.8747C339.133 28.4824 331.911 23.0893 317 23.3106C313.455 23.4001 309.925 23.8118 306.452 24.5405C286.286 28.5841 265.572 42.1278 256.888 34.9076",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.408 -15.1128C408.423 17.4351 391.784 31.6227 378.961 36.6891C370.835 39.9075 364.574 39.2027 358.789 37.6077C354.803 36.4994 351.297 34.8831 347.865 32.9745C338.035 27.5196 330.873 21.2787 315.915 21.3315C312.375 21.3805 308.85 21.7961 305.394 22.5719C285.14 26.9196 264.619 41.9544 255.537 35.3723",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.243 -17.1747C407.595 14.7293 390.942 29.2091 377.973 34.7464C369.802 38.2369 363.319 37.9934 357.539 36.6205C353.462 35.6497 349.952 34.0425 346.579 32.1089C336.932 26.5977 329.829 19.5059 314.821 19.3746C311.287 19.3815 307.766 19.8013 304.327 20.6255C283.99 25.2868 263.686 41.8262 254.178 35.8653",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.078 -19.2339C406.782 12.0268 390.105 26.7797 376.998 32.7945C368.785 36.5512 362.083 36.7752 356.308 35.6152C352.14 34.7789 348.62 33.1867 345.312 31.2406C335.841 25.6697 328.797 17.724 313.743 17.418C310.214 17.386 306.695 17.8098 303.272 18.6792C282.865 23.6793 262.755 41.676 252.828 36.3491",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.919 -21.2958C392.928 28.3992 370.094 37.0901 355.05 34.6089C338.627 31.9007 333.025 16.1079 312.641 15.4512C288.729 14.6842 263.551 42.3237 251.466 36.8296",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.703152,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.5137 102.737C69.0775 144.121 97.6029 189.759 107.941 224.382C119.477 263.022 113.528 305.253 125.981 307.876C133.955 309.556 143.767 293.786 162.061 259.217C217.535 154.39 218.791 126.552 242.426 119.326C275.536 109.198 295.946 156.848 346.839 155.821C384.218 155.065 414.465 128.534 434.852 104.95",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.5215 106.898C64.7161 147.391 94.8799 191.753 106.038 224.201C118.506 260.463 112.618 300.513 124.941 302.407C132.865 303.626 142.492 288.126 160.163 254.741C213.864 153.3 215.53 125.116 238.983 118.247C272.284 108.631 291.805 159.729 343.238 160.425C344.359 160.44 345.463 160.44 346.568 160.41C383.06 159.382 413.738 132.838 434.561 109.4",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.5215 111.057C60.3562 150.654 92.1348 193.664 104.141 224.015C117.523 257.846 111.718 295.765 123.908 296.933C131.783 297.689 141.227 282.458 158.27 250.259C210.187 152.21 212.253 123.588 235.55 117.165C269.013 107.94 287.684 162.632 339.646 165.027C340.786 165.08 341.923 165.132 343.059 165.126C380.154 164.919 412.428 137.827 434.278 113.848",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.5273 115.217C56.0017 153.931 89.3452 195.485 102.24 223.831C116.497 255.175 110.818 291.015 122.869 291.46C130.699 291.75 139.949 276.793 156.372 245.78C206.512 151.111 208.986 122.112 232.113 116.085C265.754 107.319 283.565 165.558 336.051 169.63C337.216 169.721 338.379 169.808 339.539 169.846C377.235 171.063 411.106 142.819 433.984 118.301",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.5312 119.378C51.6441 157.198 86.5015 197.21 100.339 223.648C115.416 252.452 109.926 286.261 121.834 285.988C129.62 285.81 138.678 271.128 154.478 241.301C202.838 150.018 205.723 120.641 228.677 115.008C262.507 106.705 279.453 168.507 332.457 174.24C333.647 174.366 334.838 174.492 336.033 174.571C374.327 176.892 409.795 147.815 433.705 122.752",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5371 123.539C47.2859 160.465 83.5836 198.83 98.4406 223.463C114.25 249.677 109.031 281.502 120.798 280.516C128.543 279.865 137.406 265.463 152.583 236.821C199.166 148.924 202.462 119.174 225.242 113.928C259.257 106.095 275.343 171.476 328.864 178.841C330.08 179.008 331.296 179.178 332.522 179.287C371.413 182.702 408.485 152.803 433.42 127.198",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.541 127.698C42.9271 163.734 80.5717 200.345 96.5376 223.278C112.963 246.873 108.145 276.736 119.759 275.041C127.465 273.917 136.131 259.792 150.684 232.341C195.489 147.831 199.2 117.71 221.803 112.848C256.011 105.489 271.229 174.46 325.266 183.443C326.512 183.65 327.751 183.862 329.004 184.004C368.489 188.506 407.165 157.791 433.128 131.647",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.5449 131.86C33.941 164.581 68.7453 200.171 90.1069 219.158C92.2115 221.029 93.2638 221.964 94.148 223.039C94.5075 223.477 94.9359 224.057 95.248 224.529C96.0156 225.691 96.4421 226.626 97.2951 228.496C107.351 250.546 108.124 271.786 118.723 269.571C126.391 267.968 134.86 254.133 148.79 227.856C191.816 146.732 195.941 116.247 218.367 111.763C252.768 104.886 267.119 177.459 321.671 188.043C322.94 188.288 324.209 188.541 325.494 188.72C365.576 194.296 405.859 162.781 432.846 136.093",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.5488 136.019C29.0246 167.528 64.3708 201.726 87.0842 218.841C89.8321 220.911 91.2061 221.946 92.2654 223.081C92.7122 223.56 93.1954 224.141 93.5838 224.668C94.5047 225.918 95.0239 226.963 96.0624 229.053C105.799 248.65 107.44 266.896 117.687 264.096C125.318 262.012 133.587 248.469 146.894 223.381C188.136 145.643 192.685 114.798 214.933 110.688C249.526 104.299 263.007 180.484 318.077 192.651C319.371 192.938 320.667 193.23 321.982 193.444C362.661 200.087 404.541 167.776 432.56 140.548",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.5527 140.178C24.2484 170.544 60.0692 203.427 84.0681 218.728C87.508 220.921 89.2279 222.018 90.4487 223.168C90.9834 223.671 91.5041 224.227 91.9718 224.794C93.0394 226.087 93.6592 227.215 94.8987 229.472C104.321 246.628 106.771 261.97 116.651 258.624C124.243 256.054 132.316 242.802 144.999 218.901C184.469 144.545 189.43 113.349 211.498 109.61C246.288 103.713 258.891 183.518 314.484 197.257C315.802 197.582 317.125 197.914 318.471 198.165C359.746 205.867 403.227 172.769 432.274 144.999",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.5566 144.337C19.666 173.655 55.9344 205.341 81.1685 218.84C85.2813 221.04 87.3377 222.14 88.6959 223.257C89.3145 223.766 89.852 224.27 90.3987 224.855C91.599 226.14 92.3268 227.316 93.7823 229.666C102.92 244.423 106.105 257.002 115.613 253.149C123.166 250.089 131.043 237.133 143.103 214.423C180.794 143.457 186.175 111.906 208.061 108.531C243.048 103.136 254.771 186.566 310.889 201.862C312.233 202.229 313.582 202.597 314.957 202.886C356.833 211.641 401.912 177.761 431.987 149.45",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.5605 148.501C15.2936 176.88 52.0351 207.5 78.4815 219.162C83.1829 221.235 85.5336 222.272 86.9934 223.304C87.6858 223.794 88.2151 224.224 88.8361 224.801C90.1455 226.019 90.9904 227.198 92.6801 229.558C101.589 241.995 105.431 252.003 114.576 247.673C122.088 244.119 129.771 231.466 141.206 209.937C177.119 142.357 182.92 110.461 204.626 107.446C239.813 102.558 250.649 189.616 307.295 206.46C308.665 206.867 310.036 207.274 311.445 207.594C353.922 217.397 400.598 182.743 431.702 153.89",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.5664 152.66C11.1423 180.221 48.4178 209.911 76.088 219.658C81.2259 221.467 83.7948 222.372 85.3041 223.267C86.0532 223.711 86.5418 224.046 87.2264 224.584C88.6059 225.669 89.5803 226.807 91.5291 229.083C100.296 239.322 104.721 246.987 113.54 242.205C121.008 238.154 128.498 225.803 139.31 205.46C173.45 141.267 179.667 109.029 201.188 106.37C236.573 101.998 246.518 192.692 303.699 211.067C305.093 211.516 306.496 211.959 307.935 212.321C351.015 223.159 399.287 187.746 431.418 158.346",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5664 156.818C7.19671 183.676 45.1244 212.567 74.0607 220.253C79.4193 221.677 82.0987 222.388 83.5892 223.099C84.371 223.471 84.7778 223.697 85.5078 224.163C86.8997 225.051 88.0147 226.096 90.2448 228.185C99.0008 236.391 103.952 241.97 112.504 236.73C119.928 232.18 127.226 220.137 137.416 200.98C169.773 140.171 176.415 107.593 197.752 105.288C233.34 101.439 242.384 195.776 300.104 215.669C301.525 216.16 302.955 216.641 304.42 217.039C348.104 228.916 397.969 192.731 431.136 162.795",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.5762 160.981C3.42967 187.242 42.1698 215.458 72.4473 220.884C77.7465 221.834 80.3961 222.309 81.7866 222.805C82.5684 223.084 82.8499 223.202 83.5962 223.566C84.9236 224.212 86.1812 225.108 88.6966 226.898C97.6252 233.255 103.084 236.998 111.465 231.257C118.84 226.207 125.952 214.473 135.512 196.5C166.091 139.078 173.154 106.171 194.309 104.21C230.097 100.892 238.238 198.856 296.502 220.275C297.948 220.805 299.405 221.323 300.899 221.759C345.192 234.667 396.647 197.722 430.836 167.245",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-44.5801 165.14C-0.194448 190.893 39.545 218.532 71.2634 221.443C76.1848 221.895 78.6454 222.12 79.8593 222.407C80.6019 222.582 80.7321 222.619 81.4551 222.862C82.6371 223.26 84.0061 223.946 86.744 225.318C96.0863 230 102.09 232.109 110.429 225.786C117.753 220.233 124.679 208.808 133.623 192.021C162.422 137.987 169.907 104.751 190.879 103.131C226.868 100.352 234.1 201.957 292.913 224.874C294.384 225.446 295.869 226 297.399 226.473C342.295 240.414 395.339 202.715 430.555 171.701",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.584 169.301C-3.75099 194.593 37.1718 221.708 70.4366 221.842C74.7004 221.859 76.8323 221.868 77.8186 221.982C78.4808 222.059 78.4707 222.057 79.1254 222.183C80.1005 222.37 81.4997 222.805 84.2981 223.675C94.3132 226.786 100.959 227.338 109.393 220.313C116.662 214.258 123.408 203.143 131.727 187.546C158.749 136.898 166.655 103.338 187.444 102.058C223.633 99.8273 229.95 205.065 289.32 229.489C290.815 230.104 292.327 230.694 293.881 231.205C339.395 246.156 394.029 207.707 430.269 176.147",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.5898 173.467C-7.30071 198.32 34.9827 224.936 69.8942 222.019C73.2843 221.736 74.9793 221.595 75.7272 221.595C76.2729 221.595 76.1783 221.593 76.7232 221.624C77.4698 221.666 78.764 221.849 81.3523 222.215C92.2912 223.764 99.7083 222.708 108.353 214.846C115.567 208.293 122.134 197.484 129.829 183.067C155.072 135.807 163.399 101.926 184.005 100.978C220.396 99.2995 225.794 208.17 285.724 234.086C287.243 234.744 288.784 235.369 290.366 235.917C336.497 251.893 392.709 212.696 429.982 180.591",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.5938 177.625C-9.36943 202.957 35.7959 214.308 73.7346 221.067C87.9312 223.596 97.3682 219.19 107.317 209.368C114.473 202.31 120.862 191.812 127.934 178.582C151.399 134.705 160.145 100.511 180.569 99.8927C217.159 98.7849 221.633 211.285 282.129 238.693C283.671 239.391 285.244 240.053 286.854 240.639C333.601 257.631 391.391 217.689 429.696 185.047",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.5977 181.784C-13.7232 206.234 32.004 228.828 71.8353 220.886C86.2039 218.02 96.4496 214.386 106.282 203.897C113.376 196.335 119.59 186.15 126.039 174.104C147.726 133.614 156.891 99.1103 177.134 98.8167C213.92 98.2823 217.467 214.406 278.534 243.299C280.102 244.041 281.702 244.734 283.342 245.36C330.744 263.27 390.081 222.681 429.414 189.497",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.6035 185.943C-18.0852 209.501 28.903 232.856 69.9341 220.7C84.4884 216.388 95.5265 209.578 105.244 198.424C112.275 190.358 118.317 180.482 124.142 169.624C144.051 132.519 153.634 97.6206 173.696 97.7353C210.678 97.947 213.251 217.618 274.938 247.902C276.529 248.688 278.159 249.414 279.827 250.078C327.837 269.047 388.765 227.673 429.122 193.948",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.6074 190.102C-22.4428 212.768 26.0468 236.858 68.0337 220.514C131.329 195.871 136.805 96.0758 170.262 96.6555C208.401 97.3159 209.181 227.143 276.316 254.797C324.931 274.823 387.457 232.664 428.837 198.396",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 0.63587,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.516539eed26d5e2a7bceebf68a129834.svg";
export { ForwardRef as ReactComponent };